<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { useClassStore, useSessionStore, useSignalRStore, useUserStore } from '../../stores';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { Session, sessionMap } from '../../types/session';
import Button from '../General/Button.vue';
import { UserRole } from '../../types/user';
import linkIcon from '../../assets/icons/link.svg';
import linkWhiteIcon from '../../assets/icons/link-white.svg';
import lockIcon from '../../assets/icons/lock.svg';
import menuIcon from '../../assets/icons/menu.svg';

import Vocab from './Vocab/Vocab.vue';
import Lecture from './Lecture/Lecture.vue';
import WorkBook from './Workbook/WorkBook.vue';
import Practice from './Practice/Practice.vue';
import Quiz from './Quiz/Quiz.vue';
import ForceScreen from '../Control/ForceScreen.vue';
import { ClassStatus } from '../../types/class';
import Summary from './Summary/Summary.vue';

const signalr = useSignalRStore()
const sessionStore = useSessionStore()
const classStore = useClassStore()
const user = useUserStore()

const tabs = {
    [Session.vocab]: Vocab,
    [Session.lecture]: Lecture,
    [Session.workbook]: WorkBook,
    [Session.practice]: Practice,
    [Session.quiz]: Quiz,
    [Session.summary]: Summary
}

function changeCurrentSession(session: Session) {
    if (user.userRole === UserRole.student && sessionStore.teacherSession) {
        return
    }

    sessionStore.currentSession = session

    if (user.userRole === UserRole.teacher && sessionStore.teacherSession) {
        signalr.forceScreen()
    }
}

function getSessionIcon(session: Session): string | undefined {
    if (!sessionStore.teacherSession) {
        return
    }

    if (sessionStore.teacherSession === session) {
        if (sessionStore.currentSession === session) {
            return linkWhiteIcon
        } else {
            return linkIcon
        }
    }

    if (user.userRole === UserRole.student) {
        return lockIcon
    }
}

const { t } = useI18n()
</script>

<template>
    <div class="flex items-center justify-between sm:justify-center gap-3">
        <div class="hidden sm:flex flex-wrap items-stretch justify-center gap-3 mx-auto">
            <Button v-for="session in Session" class="grow-0 w-36" :color="sessionStore.currentSession === session ? 'main' : 'white'" :shadow="false" :border="false" @click="changeCurrentSession(session)">
                <img v-if="getSessionIcon(session)" class="size-5" :src="getSessionIcon(session)" />
                <span class="font-normal shrink-0">{{ t(sessionMap[session]) }}</span>
            </Button>
        </div>
        <Menu as="div" class="sm:hidden relative">
            <MenuButton>
                <Button color="info" class="!p-2">
                    <img :src="menuIcon" class="size-6" />
                </Button>
            </MenuButton>
            <transition enter-active-class="transition duration-100 ease-out" enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-out"
                leave-from-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
                <MenuItems as="div" class="absolute z-10 top-0 left-full flex flex-col p-3 bg-white rounded-lg">
                    <MenuItem as="div" class="" v-for="session in Session">
                    <Button class="grow-0 w-36" :color="sessionStore.currentSession === session ? 'main' : 'white'" :shadow="false" :border="false" @click="changeCurrentSession(session)">
                        <img v-if="getSessionIcon(session)" class="size-5" :src="getSessionIcon(session)" />
                        <span class="font-normal shrink-0">{{ t(sessionMap[session]) }}</span>
                    </Button>
                    </MenuItem>

                </MenuItems>
            </transition>
        </Menu>

        <ForceScreen class="shrink-0" v-if="user.userRole === UserRole.teacher && classStore.selectedClassDetails?.state === ClassStatus.on_going" />
    </div>
    <div class="flex flex-1 w-full xl:px-20 overflow-hidden">
        <div class="max-w-full bg-white rounded-lg flex-1 border-2 border-gray-200">
            <component :is="tabs[sessionStore.currentSession]"></component>
        </div>
    </div>
</template>